import {rtkApi} from '../../apiSlice';
import {rtkActionHandler} from "@/redux/rtk/rtkHandler";
import {
    createNewTemplate,
    deleteTemplate,
    getAllTemplates,
    getTemplateById,
    updateHtmlContent,
    updateTemplate,
    updateTemplateStatus
} from "@/redux/apis/admin/templates";
import {CREAT_UPDATE_TEMPLATE, RECORD_FILTERS, UPDATE_RECORD_STATUS} from "@/app/admin/templates/page";
import {UPDATE_HTML_PROPS} from "@/app/admin/templates/[templateId]/page";

const apiWithPortalAdministrationTag = rtkApi.enhanceEndpoints?.({ addTagTypes: [] });
export const TemplatesApi = apiWithPortalAdministrationTag.injectEndpoints({
    endpoints: (builder) => ({
        getAllTemplates: builder.mutation<any, RECORD_FILTERS>({
            queryFn: async (data: RECORD_FILTERS) => {
                return rtkActionHandler(getAllTemplates(data));
            },
        }),
        createNewTemplate: builder.mutation<any, CREAT_UPDATE_TEMPLATE>({
            queryFn: async (data: CREAT_UPDATE_TEMPLATE) => {
                return rtkActionHandler(createNewTemplate(data));
            },
        }),
        updateTemplate: builder.mutation<any, CREAT_UPDATE_TEMPLATE>({
            queryFn: async (data: CREAT_UPDATE_TEMPLATE) => {
                return rtkActionHandler(updateTemplate(data));
            },
        }),
        deleteTemplate: builder.mutation<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(deleteTemplate(uid));
            },
        }),
        updateTemplateStatus: builder.mutation<any, UPDATE_RECORD_STATUS>({
            queryFn: async (data: UPDATE_RECORD_STATUS) => {
                return rtkActionHandler(updateTemplateStatus(data));
            },
        }),
        getTemplateById: builder.query<any, number>({
            queryFn: async (uid: number) => {
                return rtkActionHandler(getTemplateById(uid));
            },
        }),
        updateHtmlContent: builder.mutation<any, UPDATE_HTML_PROPS>({
            queryFn: async (data: UPDATE_HTML_PROPS) => {
                return rtkActionHandler(updateHtmlContent(data));
            },
        }),
    })
})

export const {
    useGetAllTemplatesMutation,
    useCreateNewTemplateMutation,
    useUpdateTemplateMutation,
    useDeleteTemplateMutation,
    useUpdateTemplateStatusMutation,
    useGetTemplateByIdQuery,
    useUpdateHtmlContentMutation
} = TemplatesApi